



















































import { Component, Prop, PropSync } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import VueDropzone from 'vue2-dropzone';
import FileUtil from '@/util/FileUtil';
import DropzoneList from '@/components/Form/FileUploadForm/DropzoneList/index.vue';
import Overlay from '@/components/Overlay/index.vue';

@Component({
  components: {
    DropzoneList,
    VueDropzone,
    Overlay,
  },
})
export default class Dropzone extends mixins(FileUtil) {
  @PropSync('dialog', {}) dialogSync!: boolean;

  @PropSync('auditForm', {}) auditFormSync!: boolean;

  @Prop({}) uploadHeadline!: string;

  @Prop({}) documentType!: string;

  private isError: boolean = false;

  private auditFormError: boolean = false;

  public documents: any[] = [];

  private dropzoneOptions = {
    url: '#',
    createImageThumbnails: false,
    includeStyling: false,
    previewsContainer: false,
    autoProcessQueue: false,
    uploadMultiple: true,
  };

  public async onAdded(file: any) {
    if (!file) return;
    const base64Encoded = await this.getBase64Encoded(file);

    const sizeLimit = 10777216;
    if (file.size >= sizeLimit) {
      this.isError = true;
      return;
    }
    this.isError = false;
    if (this.auditFormSync && this.documents.length > 0) {
      this.auditFormError = true;
      return;
    }
    this.auditFormError = false;

    const newFile = new File([file], file.name, { type: file.type });


    const doc: any = {
      base64Encoded,
      documentType: this.documentType,
      id: file.upload.uuid,
      name: file.name,
      type: file.type,
      size: file.size,
      expirationDate: '',
      uploadedDate: '',
      isUploaded: false,
      file: newFile,
    };
    this.documents = [...this.documents, doc];
  }

  public onMaxFiles(file: any) {
    if (!file) return;
    console.log(file);
  }

  public onUpdate(value: any, document: any) {
    const updateDocument = { ...document };
    const { id } = updateDocument;
    updateDocument.expirationDate = value;
    this.documents = this.updateItem(this.documents, id, updateDocument);
  }

  public onDelete(document: any) {
    const { id } = document;
    this.documents = this.deleteItem(this.documents, id);
  }

  public onClose() {
    this.dialogSync = !this.dialogSync;
    this.auditFormSync = false;
    this.isError = false;
    this.auditFormError = false;
    this.documents = [];
  }

  public onSave() {
    this.$emit('save', this.documents);
    this.onClose();
    this.documents = [];
  }
}
